<template>

  <div id="app">
    <!-- <link rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
        integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ"
        crossorigin="anonymous"> -->
    <component
      :is="layout"/>

  </div>
</template>

<script>
import AuthLayout from '@/layouts/auth'
import UserLayout from '@/layouts/user'
import { TLoader } from '@/components/common'
import config from 'devextreme/core/config'
import { mapGetters, mapMutations, mapState } from 'vuex'
import dx_de from 'devextreme/localization/messages/de.json'
import dx_en from 'devextreme/localization/messages/en.json'
import dx_ru from 'devextreme/localization/messages/ru.json'
import dx_fr from 'devextreme/localization/messages/fr.json'
import dx_ar from '@/i18n/languages/ar/dx_ar.json'
import dx_tr from '@/i18n/languages/tr/dx_tr.json'
import { locale, loadMessages } from 'devextreme/localization'
import 'devextreme-intl'
import IdleJs from 'idle-js'
import DataGrid from 'devextreme/ui/data_grid'
import {defaultTitle, defaultFaviconPath} from '@/config'

config({
	oDataFilterToLower: false,
	decimalSeparator: ',',
	thousandsSeparator: '.',
	forceIsoDateParsing: true
})
DataGrid.defaultOptions({
	device: { deviceType: 'desktop' },
	options: {
		// columnAutoWidth:true,
		// wordWrapEnabled:true,
		allowColumnResizing: true,
		columnResizingMode: 'widget',
		rowAlternationEnabled: true,
		sorting: {mode: 'multiple'},
		loadPanel: true
	}
})

export default {
	name: 'app',
	components: {
		AuthLayout,
		UserLayout,
		TLoader,
		defaultTitle,
		defaultFaviconPath
	},
	data () {
		return {
			loader: {
				color: '#4eb0e6',
				size: '70px'
			},
			idle: null,
			defaultTitle: defaultTitle,
			defaultFaviconPath: defaultFaviconPath
		}
	},
	computed: {
		...mapGetters('User', ['user', 'unreadChatMessageCount']),
		...mapState('User', ['permissions']),

		layout () {
			return (this.$route.meta.layout || 'auth-layout')
		}
	},
	watch: {
		$route: {
			handler (newVal, oldVal) {
				if (['/login', '/lock', '/forgot-password'].includes(newVal.path)) return
				localStorage.setItem('lastPage', newVal.path)

				if (newVal.meta.title) { document.title = newVal.meta.title } else { document.title = defaultTitle }

				const favicon = document.getElementById('favicon')
				if (newVal.meta.favicon) { favicon.setAttribute('href', newVal.meta.favicon) } else { favicon.setAttribute('href', defaultFaviconPath) }
			}
		}
	},
	created () {
		this.initDxMessages()
		this.initIdle()
		this.initPrograssBar()
		this.initToastRegistration()
	},
	methods: {
		...mapMutations('User', ['setUserUnreadMessagesCount']),
		initDxMessages () {
			loadMessages(dx_tr)
			loadMessages(dx_en)
			loadMessages(dx_ar)
			loadMessages(dx_fr)
			loadMessages(dx_ru)
			loadMessages(dx_de)
		},
		initPrograssBar () {
			this.$http.interceptors.request.use(config => {
				try {
					this.$Progress.start()
					return config
				} catch (error) {}
			})

			this.$http.interceptors.response.use(response => {
				this.$Progress.finish()
				return response
			}, error => {
				this.$Progress.fail()
				const { response: { status, data } } = error
				if (status === 500) this.$toasted.global.serverError(data)
				if (status === 403) this.$toasted.global.accessForbidden()
				if (status === 400) this.$toasted.global.badRequestError(data)
				return Promise.reject(error)
			})

			//  hook the progress bar to start before we move router-view
			this.$router.beforeEach((to, from, next) => {
				//  does the page we want to go to have a meta.progress object

				if (to.meta.progress !== undefined) {
					let meta = to.meta.progress
					// parse meta tags
					this.$Progress.parseMeta(meta)
				}

				//  start the progress bar
				this.$Progress.start()

				//  continue to next page
				next()
			})

			//  hook the progress bar to finish after we've finished moving router-view
			this.$router.afterEach(() => {
				//  finish the progress bar
				this.$Progress.finish()
			})
		},
		initToastRegistration () {
			this.$toasted.register('error', (payload) => {
				return payload.message || 'Oops.. Something Went Wrong..'
			},
			{
				type: 'error',
				icon: 'ti-face-sad',
				position: 'top-right',
				duration: 15000,
				closeOnSwipe: false,
				action: {
					text: ' X',
					onClick: (e, toastObject) => {
						toastObject.goAway(0)
					}
				}
			})

			this.$toasted.register('info', (payload) => {
				return payload.message || 'info'
			},
			{
				type: 'info',
				icon: 'ti-info-alt',
				position: 'top-right',
				duration: 15000
			})

			this.$toasted.register('serverError', (payload) => {
				return `
					<div style="padding: 10px 0px 5px 26px;width: 100%;">
						<h6 style="font-size: 1.0rem;color: #fff;padding-bottom: 5px;border-bottom: 1px solid #fff;">Server error!</h5>
						<p style="margin-bottom: 0.2rem;"><span style="font-weight: 400;">Code : </span> ${payload.ErrorCode}</p>
						<p style="margin-bottom: 0.2rem;"><span style="font-weight: 400;">Message : </span> ${payload.Exception}</p>
					</div>
				`
			},
			{
				type: 'error',
				icon: 'ti-info-alt',
				position: 'top-right',
				duration: 15000,
				closeOnSwipe: false,
				action: {
					text: ' X',
					onClick: (e, toastObject) => {
						toastObject.goAway(0)
					}
				}
			})

			this.$toasted.register('badRequestError', (payload) => {
				let toastError = ''
				let errors = payload
				for (let ei = 0; ei < errors.length; ei++) {
					if (errors[ei].key) {
						let errorKeyMessage = this.$t(errors[ei].key)
						if (errors[ei].replaceValues) errors[ei].replaceValues.map((item, i) => { errorKeyMessage = errorKeyMessage.replace(`{${i}}`, `${item}`) })

						toastError += `
                    <div style="padding: 10px 0px 5px 26px;width: 100%;">
                      <h6 style="font-size: 1.0rem;color: #fff;padding-bottom: 5px;border-bottom: 1px solid #fff;"></h5>
                      <p style="margin-bottom: 0.2rem;">${errorKeyMessage}</p>
                    </div>
                  `
					}
				}
				if (toastError) return toastError
				  else { return '' }
			},
			{
				type: 'error',
				icon: 'ti-info-alt',
				position: 'top-right',
				closeOnSwipe: false,
				action: {
					text: ' X',
					onClick: (e, toastObject) => {
						toastObject.goAway(0)
					}
				}
			})

			this.$toasted.register('accessForbidden', () => {
				return `
					<div style="padding: 10px 0px 5px 26px;width: 100%;">
						<h6 style="font-size: 1.0rem;color: #fff;padding-bottom: 5px;border-bottom: 1px solid #fff;">Access Forbidden!</h5>
						<p style="margin-bottom: 0.2rem;"><span style="font-weight: 400;">Message : </span> ${this.$t('error.forbidden')}</p>
					</div>
				`
			},
			{
				type: 'error',
				icon: 'ti-info-alt',
				position: 'top-right',
				duration: 5000
			})

			this.$toasted.register('success', (payload = null) => {
				if (!payload || !payload.message) return this.$t('toast.success')
				return payload.message
			},
			{
				duration: 5000,
				icon: 'os-icon os-icon-checkmark',
				type: 'success'
			})
		},
		initIdle () {
			this.idle = new IdleJs({
				idle: 500000000, // idle time in ms
				events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'click'], // events that will trigger the idle resetter
				onIdle: () => { this.handleOnIdle() }, // callback function to be executed after idle time
				onActive: function () {}, // callback function to be executed after back form idleness
				onHide: function () {}, // callback function to be executed when window become hidden
				onShow: function () {}, // callback function to be executed when window become visible
				keepTracking: true, // set it to false if you want to be notified only on the first idleness change
				startAtIdle: false // set it to true if you want to start in the idle state
			})

			this.idle.start()
		},
		handleOnIdle () {
			if (['/login', '/lock', '/forgot-password'].includes(this.$route.path)) return
			localStorage.removeItem('api_token')
			this.$router.push({ name: `auth.lock` })
		}
	}
}
</script>

<style lang="scss">
@import
	"./assets/fontawesome-pro/css/all.css",
	"./assets/typicons/typicons.css",
	"./assets/themefy/themify-icons.css",
	"flag-icon-css/css/flag-icon.css",
	"./assets/css/uibutton.min.css",
	'devextreme/dist/css/dx.light.css',
	'devextreme/dist/css/dx.common.css',
	"./assets/css/main.css",
	"./assets/css/mobile.css";
</style>



// WEBPACK FOOTER //
// src/App.vue